<template>
  <div>
    <a-drawer :title="title" :width="840" :visible="visible" :body-style="{ paddingBottom: '80px' }" :mask-closable="false" @close="onCancel">
      <a-spin :spinning="spinning">
        <a-form-model ref="form" :rules="rules" :model="form" layout="vertical">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-model-item label="服务名称" prop="name">
                <a-input v-model="form.name" placeholder="请输入服务名称" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="服务类型" prop="service_type">
                <a-select v-model="form.service_type" placeholder="请选择服务类型">
                  <a-select-option :value="1"> 后端 </a-select-option>
                  <a-select-option :value="2"> 前端 </a-select-option>
                  <a-select-option :value="3"> Apple </a-select-option>
                  <a-select-option :value="4"> Android </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-model-item label="负责人" prop="owner">
                <user-select v-model="form.owner" placeholder="请选择负责人" show-search />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="Sonar项目">
                <a-input v-model="form.sonar_name" placeholder="请输入Sonar项目名称" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-model-item label="代码仓库" prop="git_project">
                <gitlab-project-select v-model="form.git_project" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="所属域" prop="domain">
                <a-select v-model="form.domain" show-search placeholder="请选择所属域">
                  <a-select-option v-for="domain in domainList" :key="domain.value" :value="domain.value">{{ domain.label }} </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-model-item label="基础配置">
                <a-input v-model="form.infra_change" placeholder="请填写基础配置目录" />
              </a-form-model-item>
            </a-col>
            <a-col :span="3">
              <a-form-model-item label="自动发布">
                <a-switch v-model="form.auto_deploy" checked-children="开启" un-checked-children="关闭" />
              </a-form-model-item>
            </a-col>
            <a-col :span="3">
              <a-form-model-item label="自助发布">
                <a-switch v-model="form.self_deploy" checked-children="开启" un-checked-children="关闭" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-model-item label="主程序路径">
                <a-input v-model="form.main_path" placeholder="请填写主程序路径" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="专项测试">
                <a-checkbox-group v-model="form.special_tests" :options="Object.values(serviceSpecialTests)" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-model-item label="语言">
                <a-input v-model="form.language" placeholder="请填写语言" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="发布策略">
                <a-select v-model="form.strategy" mode="multiple">
                  <a-select-option v-for="(item, key) in serviceStrategys" :key="key" :value="item.name">
                    <a-tag :color="item.color">{{ item.name }}</a-tag>
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-form-model-item label="关联测试套件">
              <a-col v-for="(item, index) in sourceData" :key="index" :span="3" style="margin-right: 10px; margin-bottom: 5px">
                <div class="custom-border">
                  <a-avatar shape="square" :size="48" :src="item.image" @click="viewAutomation(item.task_url)" />
                </div>
              </a-col>
              <a-col :span="3">
                <div class="custom-border-add" @click="onAddService"><a-icon type="plus" /></div>
              </a-col>
            </a-form-model-item>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-model-item label="关联项目">
                <a-select v-model="form.projects" mode="multiple" :max-tag-count="5" show-search placeholder="请选择关联项目" :filter-option="utils.filterOption">
                  <a-select-option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }} </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-model-item label="备注信息">
                <a-textarea v-model="form.description" :rows="2" placeholder="请输入备注信息" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-model-item label="构建脚本">
                <code-mirror-component v-model="form.build_script" language="shell" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-model-item label="DockerFile">
                <code-mirror-component v-model="form.dockerfile" language="dockerfile" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="onCancel"> 取消 </a-button>
        <a-button type="primary" @click="onSubmit"> 提交 </a-button>
      </div>
    </a-drawer>
    <service-test-suit-modal :is-show="addVisible" :service-id="serviceId" tag="review" @close="close" @callback="testSuitListPush" />
  </div>
</template>

<script>
import { tagList } from '@/api/system/tag';
import { projectList } from '@/api/project/project';
import { serviceSpecialTests } from '@/utils/dictionary';
import { serviceAdd, serviceModify, serviceDetail, gitlabProjectList } from '@/api/system/service';

import UserSelect from '@/components/User/UserSelect';
import CodeMirrorComponent from '@/components/CodeMirrorComponent';
import GitlabProjectSelect from '@/pages/system/components/GitlabProjectSelect';
import ServiceTestSuitModal from '@/pages/system/components/ServiceTestSuitModal';

export default {
  components: { UserSelect, CodeMirrorComponent, GitlabProjectSelect, ServiceTestSuitModal },
  data() {
    return {
      serviceStrategys: {},
      serviceSpecialTests,
      addVisible: false,
      sourceData: [],
      form: {
        dockerfile: '',
        special_tests: [],
        git_project: { label: null, value: null }
      },
      projects: [],
      serviceId: null,
      visible: false,
      spinning: false,
      gitlabProjects: [],
      domainList: [
        {
          label: '通用',
          value: 'COMMON'
        },
        {
          label: '库存',
          value: 'STOCK'
        },
        {
          label: '订单',
          value: 'ORDER'
        },
        {
          label: '商品',
          value: 'GOODS'
        },
        {
          label: '营销',
          value: 'PROMOTION'
        },
        {
          label: '账户',
          value: 'ACCOUNT'
        },
        {
          label: 'BFF',
          value: 'BFF'
        },
        {
          label: '权限',
          value: 'AUTHORITY'
        },
        {
          label: 'DSP',
          value: 'DSP'
        },
        {
          label: '权益中心',
          value: 'EQUITY_CENTER'
        },
        {
          label: '用户会员',
          value: 'USER_MEMBER'
        },
        {
          label: '直播',
          value: 'LIVE'
        },
        {
          label: '乐朗',
          value: 'LUNA'
        }
      ],
      namespaces: [],
      rules: {
        name: [{ required: true, message: '服务名称不能为空', trigger: 'blur' }],
        owner: [{ required: true, message: '负责人不能为空', trigger: 'blur' }],
        git_project: [{ required: true, message: '代码仓库不能为空', trigger: 'blur' }],
        namespace: [{ required: true, message: '命名空间不能为空', trigger: 'blur' }],
        service_type: [{ required: true, message: '服务类型不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    title() {
      return this.serviceId ? '修改服务' : '添加服务';
    }
  },
  methods: {
    onOpen(serviceId) {
      this.visible = true;
      this.serviceId = serviceId;
      this.getTagData();
      this.getProjectList();
      if (this.serviceId) {
        this.spinning = true;
        this.getServiceDetail();
      } else {
        this.form = {
          auto_deploy: true,
          self_deploy: true,
          special_tests: [],
          domain: 'COMMON'
        };
      }
    },
    onCancel() {
      this.form = {};
      this.$refs.form.resetFields();
      this.visible = false;
    },
    testSuitListPush(testSuit) {
      console.log(testSuit);
      this.sourceData.push(testSuit);
      this.form.test_suit = this.sourceData;
    },
    onAddService() {
      this.modifyService = {};
      this.modifyIndex = null;
      this.addVisible = true;
    },
    viewAutomation(url) {
      window.open(url);
    },

    close() {
      this.addVisible = false;
    },

    getTagData() {
      tagList({ group_code: 'release_strategy' }).then(res => {
        const tags = {};
        res.data.items.forEach(item => {
          tags[item.name] = item;
        });
        this.serviceStrategys = tags;
      });
    },

    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          const params = { ...this.form, git_id: this.form.git_project.key };
          delete params.git_project;
          if (this.serviceId) {
            serviceModify({ ...params, service_id: this.serviceId })
              .then(() => {
                this.$message.success('修改成功');
                this.visible = false;
                this.$emit('ok');
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            serviceAdd(params)
              .then(() => {
                this.$message.success('添加成功');
                this.visible = false;
                this.$emit('ok');
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },

    // 获取Gitlab项目列表
    async getGitlabProjectList() {
      const { code, data } = await gitlabProjectList({});
      if (code === 2000) {
        this.gitlabProjects = data.gitlab_projects;
      }
    },

    // 获取项目列表
    async getProjectList() {
      const { code, data } = await projectList({});
      if (code === 2000) {
        this.projects = data.projects;
      }
    },

    // 获取服务详情
    async getServiceDetail() {
      const { code, data } = await serviceDetail({ service_id: this.serviceId });
      if (code === 2000) {
        this.form = {
          name: data.name,
          git_id: data.git_id,
          domain: data.domain,
          service_type: data.service_type.value,
          owner: data.owner.id,
          namespace: data.namespace,
          sonar_name: data.sonar_name,
          description: data.description,
          build_script: data.build_script,
          dockerfile: data.dockerfile,
          infra_change: data.infra_change,
          auto_deploy: data.auto_deploy,
          self_deploy: data.self_deploy,
          main_path: data.main_path,
          special_tests: data.special_tests,
          language: data.language,
          test_suit: data.test_suit,
          strategy: data.strategy || [],
          projects: data.projects.map(project => project.project_id),
          git_project: { label: data.git_name, key: data.git_id, value: data.git_id }
        };
        this.sourceData = data.test_suit;
        this.spinning = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.http-url {
  color: rgb(133, 133, 133);
}
/deep/.ant-form-item {
  margin-bottom: 8px;
}
/deep/.ant-checkbox-group {
  margin: 4px 0;
}

/deep/.ant-switch {
  margin: 4px 0;
}
.custom-border {
  width: 100%;
  height: 100px;
  border: 1px solid #e0e0e0; /* 使用更浅的灰色作为边框颜色 */
}
.custom-border-add {
  width: 100%;
  height: 100px;
  border: 1px solid #e0e0e0; /* 使用更浅的灰色作为边框颜色 */
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}
</style>
